import { useEffect } from 'react';

interface TelegramWebApp {
  ready: () => void;
  expand: () => void;
  close: () => void;
  initData: string;
  initDataUnsafe: {
    user?: {
      id: number;
      first_name: string;
      last_name?: string;
      username?: string;
      language_code?: string;
    };
    auth_date?: number;
    hash?: string;
  };
  colorScheme: 'light' | 'dark';
  themeParams: Record<string, string>;
  HapticFeedback: {
    impactOccurred: (style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft') => void;
    notificationOccurred: (type: 'error' | 'success' | 'warning') => void;
    selectionChanged: () => void;
  };
  MainButton: {
    text: string;
    show: () => void;
    hide: () => void;
    onClick: (cb: () => void) => void;
    offClick: (cb: () => void) => void;
    enable: () => void;
    disable: () => void;
    setText: (t: string) => void;
  };
  BackButton: {
    show: () => void;
    hide: () => void;
    onClick: (cb: () => void) => void;
    offClick: (cb: () => void) => void;
  };
  setHeaderColor: (color: string) => void;
  setBackgroundColor: (color: string) => void;
}

declare global {
  interface Window {
    Telegram?: { WebApp: TelegramWebApp };
  }
}

export function getTelegram(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function useTelegram() {
  const tg = getTelegram();

  useEffect(() => {
    if (!tg) return;
    tg.ready();
    tg.expand();
    tg.setHeaderColor('#0B0F12');
    tg.setBackgroundColor('#0B0F12');
  }, [tg]);

  const haptic = (
    style: 'light' | 'medium' | 'heavy' | 'success' | 'error' = 'light',
  ) => {
    if (!tg) return;
    try {
      if (style === 'success') tg.HapticFeedback.notificationOccurred('success');
      else if (style === 'error') tg.HapticFeedback.notificationOccurred('error');
      else if (['light', 'medium', 'heavy', 'rigid', 'soft'].includes(style)) {
        tg.HapticFeedback.impactOccurred(style as any);
      }
    } catch {}
  };

  return {
    tg,
    user: tg?.initDataUnsafe?.user,
    initData: tg?.initData ?? '',
    haptic,
  };
}
